import getIcon from "Components/icons/technologies";

const SPECIAL_IMAGE_TYPES = ["composable", "external"] as const;

export type SpecialImageType = (typeof SPECIAL_IMAGE_TYPES)[number];

export const isSpecialImageType = (
  type: string | undefined
): type is SpecialImageType =>
  SPECIAL_IMAGE_TYPES.includes(type as SpecialImageType);

export const getImageTypeIconSrc = (type: SpecialImageType): string =>
  `data:image/svg+xml;base64,${window.btoa(
    getIcon(type, 0, 0, 24, 24, undefined)
  )}`;

export const getImageTypeTranslationId = (type: SpecialImageType): string =>
  `services.keys.${type}`;
